module.exports = __webpack_public_path__ + "media/img/baner_SKPQ-1db0bfbd.gif";